import { render, staticRenderFns } from "./faultType.vue?vue&type=template&id=5776dcaa&scoped=true&"
import script from "./faultType.vue?vue&type=script&lang=js&"
export * from "./faultType.vue?vue&type=script&lang=js&"
import style0 from "./faultType.vue?vue&type=style&index=0&id=5776dcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776dcaa",
  null
  
)

export default component.exports